export const routesConstant = ["/", "/about", "/product", "/client-page", "/service-page", "/career-page"];
export const routeNames = ["Home", "About", "Product", "Client", "Service", "Career"];
export const routeMenuProducts = ["/product/smart-stock", "/product/pos", "/product/omni-channel", "/product/integrated-healthcare", "/product/digital-signature", "/product/customer-loyalty", "/product/big-data"];
export const routeMenuAbouts = ["/about/corporate-profile", "/about/peentar-value"];
export const menuProductNames = ["Smartstock", "Pos", "Omni Channel", "Integrated Healthcare", "Digital Signature", "Customer Loyalty", "Big Data"];

export const menuAboutNames = ["Corporate Value", "Peentar Value"];
